import { MAX_CONVERSATION_UPLOAD_BYTES } from '@/constants/UploadLimits';

/**
 * File answers are stored in the conversation as base64 data URLs, so the
 * upload budget is measured by decoding those strings back to a byte count.
 */
const getDataUrlByteSize = (dataUrl) => {
  if (typeof dataUrl !== 'string') return 0;
  // Four base64 characters encode one, two, or three bytes depending on the
  // trailing '=' padding — counting them as three rejects exact-fit uploads.
  const base64Length = dataUrl.length - (dataUrl.indexOf(',') + 1);
  let padding = 0;
  if (dataUrl.endsWith('==')) {
    padding = 2;
  } else if (dataUrl.endsWith('=')) {
    padding = 1;
  }
  return Math.max(0, Math.floor((base64Length * 3) / 4) - padding);
};

const getAnswerByteSize = (answer) => {
  if (Array.isArray(answer)) {
    return answer.reduce((total, item) => total + getAnswerByteSize(item), 0);
  }
  return getDataUrlByteSize(answer?.data);
};

/** Total size of every document already uploaded in this conversation. */
export const getConversationUploadBytes = (conversation) => {
  if (!Array.isArray(conversation)) return 0;
  return conversation.reduce((total, block) => total + getAnswerByteSize(block?.answer), 0);
};

/** How much more the candidate can upload before the conversation gets too big. */
export const getRemainingUploadBytes = (conversation) =>
  Math.max(0, MAX_CONVERSATION_UPLOAD_BYTES - getConversationUploadBytes(conversation));

export { getDataUrlByteSize };
